import React from 'react';
import moment from 'moment';

import ListResource from './ListResource.jsx';

const ListViewSlots = () => (
  <ListResource
    {...{
      searchable: true,
      api: '/api/site/view-slots',
      actions: {
        create: false,
        remove: false,
      },
      sort: { key: 1 },
      cols: [
        { key: 'key', sortable: true },
        { key: 'format', sortable: true },
        {
          key: 'updatedAt',
          getter: (v) => moment(v).format('YYYY/M/D h:mm a'),
        },
      ],
    }}
  />
);

export default ListViewSlots;
